import { TranslateService } from '@ngx-translate/core';

/** First breadcrumb item, pointing at the home page (`url` as expected by the breadcrumb component used). */
export function homeCrumb(translate: TranslateService, url = '/'): { label: string; url: string } {
  return { label: translate.instant('bread-crumbs-home'), url };
}
